// extracted by mini-css-extract-plugin
export default {"header":"Home_header__EafZu","banner":"Home_banner__BryGQ","step":"Home_step__lc9bY","stepNumber":"Home_stepNumber__iXhQJ"};